export default {
  TITLE: 'Hero Hive',
  HQS_ACTIVE: ['Düsseldorf'],
  HQS_INACTIVE: [],
}
